import Vue from 'vue'

const BASE_URL = process.env.BASE_URL

Vue.component('vue-alphabet-filter', {
  template: '#vue-alphabet-filter-template',
  props: [],
  data() {
    return {
      links: [],
      baseUrl: process.env.BASE_URL,
      alphabetLetters: [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
      ],
    }
  },
  methods: {
    generateUrlsArrray() {
      this.links = this.alphabetLetters.map(element => {
        return { url: `${this.baseUrl}produkty?search=${element}`, letter: element }
      })
    },
  },
  mounted() {
    this.generateUrlsArrray()
  },
})
